import React from "react";
import { GraphTableInfoToggle } from "./TogglePanel";

export interface PlainPanelProps {
    title?: string | JSX.Element;
}

export const PlainPanel: React.FC<PlainPanelProps> = ({ title, children }) => {
    return <GraphTableInfoToggle title={title ?? ""} graph={<>{children}</>} />;
};

export const PlainPanelDemo = () => {
    return (
        <PlainPanel>
            <div>www</div>
            <div>www</div>
        </PlainPanel>
    );
};
